import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Officiell publik domän — där all SEO ska samlas.
// Byt vid behov om subdomänen ändras.
const CANONICAL_HOST = "https://access.lagamobilen.se";

// Hostar som INTE ska indexeras av Google (preview, staging, lovable.app).
function shouldNoIndex(host: string): boolean {
  return (
    host.endsWith(".lovable.app") ||
    host.endsWith(".lovable.dev") ||
    host.endsWith(".lovableproject.com") ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
}

function upsertMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sätter rel=canonical mot den officiella domänen och lägger
 * robots=noindex på alla preview/lovable.app-hostar så att Google
 * bara indexerar access.lagamobilen.se.
 */
export function CanonicalAndRobots() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname;
    const path = location.pathname + location.search;
    const canonical = `${CANONICAL_HOST}${path}`;

    upsertLink("canonical", canonical);
    upsertMeta("og:url", canonical, "property");

    if (shouldNoIndex(host)) {
      upsertMeta("robots", "noindex, nofollow");
    } else {
      // Custom domain → tillåt indexering
      const existing = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
      if (existing) existing.setAttribute("content", "index, follow");
    }
  }, [location.pathname, location.search]);

  return null;
}
